import React from 'react';
import { Box, Chip } from '@mui/material';

/** Contrast text for a hex background. */
export function labelTextColor(bgHex) {
  const hex = String(bgHex || '#64748b').replace('#', '');
  if (hex.length !== 6) return '#fff';
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.62 ? '#111' : '#fff';
}

/**
 * Colored chips for part labels.
 */
const PartLabelChips = ({ labels = [], size = 'small', max = 6, onClickLabel }) => {
  const list = Array.isArray(labels) ? labels.filter(Boolean) : [];
  if (list.length === 0) {
    return (
      <Box component="span" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
        —
      </Box>
    );
  }
  const shown = list.slice(0, max);
  const extra = list.length - shown.length;
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
      {shown.map((lab) => (
        <Chip
          key={lab.id ?? lab.name}
          label={lab.name}
          size={size}
          onClick={
            onClickLabel
              ? (e) => {
                  e.stopPropagation();
                  onClickLabel(lab);
                }
              : undefined
          }
          sx={{
            height: size === 'small' ? 22 : 28,
            fontSize: size === 'small' ? '0.7rem' : '0.8rem',
            fontWeight: 600,
            bgcolor: lab.color || '#64748b',
            color: labelTextColor(lab.color),
            '& .MuiChip-label': { px: 0.75 },
            cursor: onClickLabel ? 'pointer' : 'default'
          }}
        />
      ))}
      {extra > 0 && (
        <Chip
          label={`+${extra}`}
          size={size}
          variant="outlined"
          sx={{ height: size === 'small' ? 22 : 28, fontSize: '0.7rem' }}
        />
      )}
    </Box>
  );
};

export default PartLabelChips;
